// extracted by mini-css-extract-plugin
export default {"modal":"CandidateModal_modal__Uh8AN"};